import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/explore")({
  beforeLoad: ({ location }) => {
    // Redirect bare /explore to the suppliers sub-route (default tab)
    const p = location.pathname.replace(/\/+$/, "")
    if (p === "/explore") {
      throw redirect({ to: "/explore/suppliers", replace: true })
    }
  },
})